export const environment = {
  production: true,
  unleash: {
    clientKey: "f7rwWTkV4ZhrjKiNZUjjplCAh51UEsZ5k6F1ewMqUTlS0HZQFa",
  }
};



// WEBPACK FOOTER //
// /opt/app-root/src/src/environments/environment.ts